import { handleRedirectionWithSignupSource } from '@common/utils'
import { LazyImage } from '@components/common/image'
import Router from 'next/router'

const BOOK_FREE_CLASS_LINK = '/register/'
const IMAGE_PATH = '/images/national-coding-olympiad/thank-you-page/banner/'

const Banner = () => (
  <a
    onClick={() =>
      handleRedirectionWithSignupSource(Router.asPath, BOOK_FREE_CLASS_LINK)
    }
  >
    <div className="container mx-auto relative -mb-12 z-10 hidden md:block">
      <div className="flex justify-center">
        <LazyImage
          path={IMAGE_PATH}
          name="banner-bg"
          alt="nco-2021 thank you page banner"
        />
      </div>
      <div className="absolute top-0 mt-16 pt-2 ml-48 flex flex-col">
        <p className="font-700 text-white text-3xl">
          Start building apps, websites, and <br className="hidden md:block" />{' '}
          games with 1-on-1 coding classes
        </p>
        <button className="flex justify-center w-56 py-3 px-8 mt-5 text-xl btn border-orange text-orange font-600 bg-white hover:bg-orange-200">
          Try a free lesson
        </button>
      </div>
    </div>

    <div className="container mx-auto relative -mb-6 z-10 md:hidden">
      <LazyImage
        path={IMAGE_PATH}
        name="banner-phone-bg"
        className="w-full"
        alt="nco-2021 thank you page banner"
      />
      <div className="absolute top-0 mt-12 flex-col justify-center px-8">
        <p className="font-700 text-white text-center text-4xl leading-snug">
          Start building apps, websites, and <br className="hidden md:block" />{' '}
          games with 1-on-1 coding classes
        </p>
        <div className="flex justify-center pt-4">
          <button className="flex justify-center w-56 py-3 px-8 mt-10 text-xl btn border-orange text-orange font-600 bg-white hover:bg-orange-200">
            Try a free lesson
          </button>
        </div>
      </div>
    </div>
  </a>
)

export default Banner
